import { h } from '@atomify/jsx';
import { getMapInstance } from '@bpd-library/components';
import { ButtonRound } from '@source/components/atoms/button-round/button-round';
import { GTMPush } from '@utilities/gtm';

interface MapControlsInterface {
    classes?: string;
    sunDirection?: boolean;
}

const MapControls = ({ sunDirection, classes = '' }: MapControlsInterface) => {
    return (
        <div class={`c-map-controls ${classes}`}>
            <ButtonRound
                ariaLabel="Zoom in"
                classes="map-controls__button"
                size="small"
                svg="icons-plus"
                onClick={() => {
                    GTMPush({
                        event: 'Map Interaction',
                        eventCategory: 'Map',
                        eventAction: 'Zoom filter',
                        eventLabel: 'zoom_in',
                    });
                    getMapInstance()?.zoomIn();
                }}
            />
            <ButtonRound
                ariaLabel="Zoom uit"
                classes="map-controls__button"
                size="small"
                svg="icons-minus"
                onClick={() => {
                    GTMPush({
                        event: 'Map Interaction',
                        eventCategory: 'Map',
                        eventAction: 'Zoom filter',
                        eventLabel: 'zoom_out',
                    });
                    getMapInstance()?.zoomOut();
                }}
            />

            {sunDirection && (
                <ButtonRound ariaLabel="icon" size="small" svg="arrow-sun-direction" disabled />
            )}
        </div>
    );
};

export default MapControls;
